import React from 'react';
import { useQuery } from '@apollo/client/react';
import {
    GetDemobDetails,
    GetDemobDetails_getDemobDetails as DemobDetailsResponseType,
    GetDemobDetails_getDemobDetails_stats as DemobDetailsType,
} from '../../../../types/schemaTypes';
import { GET_DEMOB_DETAILS } from '../../../../graphql/client/queries';
import { Loading, Error } from '../../../_common';
import { OverlayTrigger } from 'react-bootstrap';
import moment from 'moment';

interface DemobilizationProps {
    jobId: number;
    destination: string;
    destinationType: string;
    destinationId: number;
    demobDetailsFromSignalr: DemobDetailsResponseType | undefined;
    handleOnClickEditLeapFrog: (isLeapFrog: boolean) => void;
}

const Demobilization = ({
    jobId,
    destination,
    destinationType,
    destinationId,
    demobDetailsFromSignalr,
    handleOnClickEditLeapFrog,
}: DemobilizationProps): React.ReactElement => {
    const { data, loading, error, previousData } = useQuery<GetDemobDetails>(GET_DEMOB_DETAILS, {
        variables: {
            input: {
                destinationType: destinationType ?? '-1',
                destinationId: destinationId ?? -1,
                originId: jobId,
            }
        },
        fetchPolicy: 'network-only',
    });

    let demobDetails: DemobDetailsType[] = [];
    let mobStatus = '';
    let leapFrog = false;
    let mobDate = '';
    let mobEndDate = '';
    if (data && data.getDemobDetails?.stats) {
        console.log('Demob - Fetched API data')
        data.getDemobDetails.stats.map(demobDetail => {
            if (demobDetail)
                demobDetails.push(demobDetail);
        })
        mobStatus = data.getDemobDetails.jobInfo?.mobStatus ?? '';
        leapFrog = data.getDemobDetails.jobInfo?.leapFrog ?? false;
        mobDate = data.getDemobDetails.jobInfo?.mobDate ?? '';
        mobEndDate = data.getDemobDetails.jobInfo?.mobEndDate ?? '';
    } else if (previousData && previousData.getDemobDetails?.stats) {
        previousData.getDemobDetails.stats.map(demobDetail => {
            if (demobDetail)
                demobDetails.push(demobDetail);
        })
        mobStatus = previousData.getDemobDetails.jobInfo?.mobStatus ?? '';
        leapFrog = previousData.getDemobDetails.jobInfo?.leapFrog ?? false;
        mobDate = previousData.getDemobDetails.jobInfo?.mobDate ?? '';
        mobEndDate = previousData.getDemobDetails.jobInfo?.mobEndDate ?? '';
    }

    if (demobDetailsFromSignalr && demobDetailsFromSignalr.stats) {
        demobDetails = [];
        demobDetailsFromSignalr.stats.map(demobDetail => {
            if (demobDetail)
                demobDetails.push(demobDetail);
        })
        mobStatus = demobDetailsFromSignalr.jobInfo?.mobStatus ?? '';
        leapFrog = demobDetailsFromSignalr.jobInfo?.leapFrog ?? false;
        mobDate = demobDetailsFromSignalr.jobInfo?.mobDate ?? '';
        mobEndDate = demobDetailsFromSignalr.jobInfo?.mobEndDate ?? '';
    }


    const formatDate = (text: string | null): string => {
        if (text === null || text === '') return '';
        const newDate = moment(text).format('MMM DD, YYYY');
        return newDate;
    };

    return (
        <div className="Equipments-Container">
            {loading && (
                <div className="Equipments-Spinner">
                    <Loading />
                </div>
            )}
            {
                error ? (
                    <Error error={error} />
                ) : (
                    <div className="Equipments-MobDemob-Container">
                        {!loading &&
                            <div>
                                <div className="Equipments-MobDemob-JobDetails-Container">
                                    {mobStatus !== "" && (
                                        <div className="Equipments-MobStatus-Container">
                                            <i className="material-icons Equipments-MobStatus-Icon">
                                                cached
                                            </i>
                                            {mobStatus}
                                        </div>
                                    )}

                                    <div className="Equipments-MobDate-Container">
                                        Start: <span className="Equipments-MobDate">{formatDate(mobDate)}</span>
                                    </div>

                                    <div className="Equipments-MobDate-Container">
                                        End: <span className="Equipments-MobDate">{formatDate(mobEndDate)}</span>
                                    </div>
                                </div>

                                <label className="Equipments-Leapfrog-Container">
                                    <input
                                        type='checkbox'
                                        className='Equipments-Leapfrog'
                                        id='EditJob-Leapfrog-Checkbox'
                                        checked={leapFrog}
                                        onChange={event => { handleOnClickEditLeapFrog(event.target.checked) }}
                                    />
                                    LEAPFROG
                                </label>
                            </div>
                        }

                        <table className="Equipments-MobDemob-Grid" cellPadding={2} cellSpacing={2}>
                            <thead className="Equipments-MobDemob-Grid-Header">
                                <tr>
                                    <th className="Equipments-MobDemob-Grid-Head Equipments-MobDemob-Data-LeftAlign">
                                        Asset Name
                                        <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <div className="Equipments-MobDemob-Tooltip">
                                                    Data reflected in this grid indicates the individual count of assets
                                                </div>
                                            }
                                        >
                                            <i className="material-icons color Equipments-Info-Icon">info</i>
                                        </OverlayTrigger>
                                    </th>
                                    <th>Delivered/ Mobilized</th>
                                    <th>Available Assets</th>
                                    <th>Created</th>
                                    <th>Ready for Dispatch</th>
                                    <th>In-Route</th>
                                    <th>Demobilized</th>
                                    <th className="Equipments-MobDemob-Grid-Head">
                                        Additional Needed
                                        <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <div className="Equipments-MobDemob-Tooltip">
                                                    Count of assets still needed to meet planned quantity at {destinationId === -1 ? 'destination' : destination}
                                                </div>
                                            }
                                        >
                                            <i className="material-icons color Equipments-Info-Icon">info</i>
                                        </OverlayTrigger>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    demobDetails.map((demobDetail, index) => {
                                        if (
                                            demobDetail.actualQty ||
                                            demobDetail.availableQty ||
                                            demobDetail.created ||
                                            demobDetail.readyForDispatch ||
                                            demobDetail.inRoute ||
                                            demobDetail.delivered ||
                                            demobDetail.additionalNeeded
                                        )
                                            return (
                                                <tr key={index}>
                                                    <td className="Equipments-MobDemob-Data-LeftAlign">{demobDetail?.assetType}</td>
                                                    <td>{demobDetail?.actualQty && demobDetail?.actualQty !== 0 ? demobDetail.actualQty : '-'}</td>
                                                    <td>{demobDetail?.availableQty && demobDetail?.availableQty !== 0 ? demobDetail.availableQty : '-'}</td>
                                                    <td>{demobDetail?.created && demobDetail?.created !== 0 ? demobDetail.created : '-'}</td>
                                                    <td>{demobDetail?.readyForDispatch && demobDetail?.readyForDispatch !== 0 ? demobDetail.readyForDispatch : '-'}</td>
                                                    <td>{demobDetail?.inRoute && demobDetail?.inRoute !== 0 ? demobDetail.inRoute : '-'}</td>
                                                    <td>{demobDetail?.delivered && demobDetail?.delivered !== 0 ? demobDetail.delivered : '-'}</td>
                                                    <td>{demobDetail?.additionalNeeded && demobDetail?.additionalNeeded !== 0 ? demobDetail.additionalNeeded : '-'}</td>
                                                </tr>
                                            )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                )
            }
        </div>
    );
};

export default Demobilization;

